import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import { countPendingProjects } from "@/lib/hooks/pending-projects-count"
import { useSelectedTeamIds } from "@/lib/use-team-filter"
import { useZeroWorkspace } from "@/lib/zero"
import { useActivePortalInstance } from "@/stores/active-portal-instance-store"

export function usePendingProjectsCount() {
	const workspace = useZeroWorkspace()
	const [pendingProjects] = useQuery(queries.pendingProjects({}))

	const selectedTeamIds = useSelectedTeamIds()
	const portalInstances = workspace?.portalInstances ?? []
	const multiPortalActive = portalInstances.length >= 1
	const [activePortalInstanceId] = useActivePortalInstance(portalInstances)

	return useMemo(
		() =>
			countPendingProjects(pendingProjects, {
				multiPortalActive,
				activePortalInstanceId,
				selectedTeamIds,
			}),
		[
			pendingProjects,
			multiPortalActive,
			activePortalInstanceId,
			selectedTeamIds,
		],
	)
}
